import { store } from '../store/global-store';

export const AdvertActionsCommands = Object.freeze({
    OpenCascadeModal: 'openCascadeModal',
    NavigateCascadeModal: 'navigateCascadeModal',
});

export const advertActions = {
    openCopyAsModal(model) {
        store.commit('openCopyAsModal', model);
    },
    closeCopyAsModal() {
        store.commit('closeCopyAsModal');
    },
    openCascadeModal(model, type) {
        store.commit(AdvertActionsCommands.OpenCascadeModal, { model, type });
    },
    openSoldModal(model) {
        store.commit('openSoldModal', model);
    },
    closeSoldModal() {
        store.commit('closeSoldModal');
    },
    openRentedModal(model) {
        store.commit('openRentedModal', model);
    },
    closeRentedModal() {
        store.commit('closeRentedModal');
    },
};